export default String.raw`
.textElement {
    $height: 415px;
    margin: 0 auto;
    padding: 32px 9%;
    background-color: $textElementBg;
    width: 100%;
    position: relative;
    max-height: $height;
    overflow: hidden;

    &__container {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        height: calc(100% - 64px);
        overflow-y: visible;

        &-column {
           p {
                margin-top: 16px;
                @include body-1-regular;
                color: $textElementFont;

                &:first-child {
                    margin-top: 0;
                }
           }

           h3 {
                margin-top: 16px;
                color: $textElementFont;

                &:first-child {
                    margin-top: 0;
                }
           }
        }
    }

    &__gradient {
        width: 100%;
        height: $height;
        background: linear-gradient(0deg, $textElementBg 0%, rgba(248, 249, 250, 0.00) 100%);
        position: absolute;
        bottom: 0;
        visibility: hidden;
    }

    &__hidder {
        position: absolute;
        bottom: 0;
        visibility: hidden;
        background-color: $textElementBg;
        width: 100%;
        height: 72px;
        padding-top: 16px;

        &-button {
            display: flex;
            align-items: center;
            @include button;
            color: $iconColors;
            user-select: none;
            cursor: pointer;
            width: fit-content;

            &-rollIn {
                display: none;
            }
    
            svg {
                width: 16px;
                height: 16px;
                margin-left: 4px;
                fill: $iconColors;
                rotate: 90deg;
            }

            &:hover {
                color: $hoverOverButton;

                svg {
                    fill: $hoverOverButton;
                }
            }
        }
    }

    &.open {
        max-height: none;

        .textElement {
            &__hidder {
                &-button {
                    &-rollOut {
                        display: none;
                    }

                    &-rollIn {
                        display: inline;
                    }

                    svg {
                        rotate: -90deg;
                    }
                }
            }

            &__gradient {
                display: none;
            }
        }
    }
}

.products-page {
    .textElement {
        margin-bottom: 30px;
    }
}
`